export default "__VITE_ASSET__DorzOgLp__"